<template>
  <div
    class="burger"
    :class="{'active': isNavOpen}"
    @click.prevent="toggleNav"
  >
    <div>
      <button
        type="button"
        class="burger-button ml16"
        title="Menu"
      >
        <span class="burger-bar burger-bar--1" />
        <span class="burger-bar burger-bar--2" />
        <span class="burger-bar burger-bar--3" />
      </button>
    </div>
  </div>
</template>

<script src="./js/burger.js"></script>

<style lang="scss" scoped>
@import '@blibli/blue-dls-utils/dist/scss/responsive-mixins-helper';
@import '@blibli/blue-design-tokens/dist/tokens-default.scss';

.hidden {
  visibility: hidden;
}
button {
  cursor: pointer;
  &:focus {
    outline: 0;
  }
}
.burger {
  &-button {
    position: relative;
    height: 30px;
    width: 32px;
    display: block;
    z-index: 20;
    border: 0;
    border-radius: 0;
    background-color: transparent;
    pointer-events: all;
    -webkit-transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  }
  &-bar {
    background-color: $blu-color-neutral-icon-default;
    position: absolute;
    top: 50%;
    right: 6px;
    left: 6px;
    height: 3px;
    width: auto;
    margin-top: -1px;
    border-radius: 8px;
    -webkit-transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
      opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1),
      background-color 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
      opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1),
      background-color 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    &--1 {
      -webkit-transform: translateY(-6px);
      transform: translateY(-6px);
    }
    &--2 {
      transform-origin: 100% 50%;
    }
    &--3 {
      transform: translateY(6px);
    }
  }
  &.active {
    .burger-button {
      transform: rotate(-180deg);
    }
    .burger-bar {
      @include desktop { background-color: $blu-color-neutral-icon-default; }
      @include mobile { background-color: $blu-color-neutral-icon-default; }
      @include desktop { background-color: $blu-color-neutral-icon-default; }
      &--1 {
        transform: rotate(45deg);
      }
      &--2 {
        opacity: 0;
      }
      &--3 {
        transform: rotate(-45deg);
      }
    }
  }
}
div {
  .sticky {
    .burger {
      &-bar {
        @include mobile {
          background-color: $blu-color-neutral-icon-default;
        }
      }
    }
  }
  .home {
    .sticky {
      .burger {
        &-bar {
          @include mobile {
            background-color: $blu-color-neutral-icon-default;
          }
        }
        &.active {
          .burger-bar {
            background-color: $blu-color-neutral-icon-default;
          }
        }
      }
    }
  }
}
</style>
